<template>
  <div class="duplicate-overlay" @click.self="$emit('back')">
    <div class="duplicate-modal">
      <div class="header">
        <span class="error-title">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="9" stroke="#dc3545" stroke-width="2" />
            <line
              x1="12"
              y1="7"
              x2="12"
              y2="13"
              stroke="#dc3545"
              stroke-width="2"
              stroke-linecap="round"
            />
            <circle cx="12" cy="16.5" r="1.1" fill="#dc3545" />
          </svg>
          Błąd
        </span>
        <p class="error-subtitle">{{ personLabel }} z tymi danymi już istnieje!</p>
      </div>

      <div class="info-card" :class="{ 'info-card--single': fields.length === 1 }">
        <div v-for="field in fields" :key="field.label" class="info-row">
          <span class="info-label">{{ field.label }}</span>
          <span class="info-value">{{ field.value }}</span>
        </div>
      </div>

      <p class="question">
        Czy chcesz przejść do profilu tego {{ personGenitive }}?
      </p>

      <div class="divider"></div>

      <div class="buttons">
        <custom-button
          :title="'Wróć'"
          :customStyles="'width: auto; height: 40px; padding: 0 40px; margin-top: 0; border-radius: 12px;'"
          @click="$emit('back')"
        />
        <custom-button
          :gradient="true"
          :title="'Przejdź do profilu'"
          :customStyles="'width: auto; height: 40px; padding: 0 40px; margin-top: 0; border-radius: 12px;'"
          @click="$emit('goToProfile')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "../CustomButton.vue";

export default {
  name: "DodDuplicateFoundModal",
  components: { CustomButton },
  props: {
    // 'customer' albo 'employee' - decyduje o rzeczowniku i o tym, które pola pokazać
    type: {
      type: String,
      default: "customer",
    },
    person: {
      type: Object,
      required: true,
    },
  },
  emits: ["back", "goToProfile"],
  computed: {
    isEmployee() {
      return this.type === "employee";
    },
    personLabel() {
      return this.isEmployee ? "Opiekun" : "Podopieczny";
    },
    personGenitive() {
      return this.isEmployee ? "opiekuna" : "podopiecznego";
    },
    // Opiekuna duplikat wykrywamy po PESEL-u, podopiecznego po imieniu, nazwisku i telefonie -
    // dlatego karta pokazuje dokładnie te pola, po których nastąpiło dopasowanie.
    fields() {
      if (this.isEmployee) {
        return [{ label: "PESEL", value: this.person.pesel }];
      }
      return [
        { label: "Imię", value: this.person.firstName },
        { label: "Nazwisko", value: this.person.lastName },
        { label: "Telefon", value: this.formatPhone(this.person.phone) },
      ];
    },
  },
  methods: {
    formatPhone(phone) {
      const digits = (phone || "").replace(/\D/g, "");
      // 9-cyfrowy numer w standardowym formacie rozbijamy na grupy 3-3-3 dla czytelności.
      if (digits.length === 9) {
        return digits.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
      }
      return phone;
    },
  },
};
</script>

<style scoped>
.duplicate-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(9, 7, 65, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
.duplicate-modal {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 30px 0 rgba(9, 7, 65, 0.25);
  padding: 28px 32px;
  width: 480px;
  max-width: 90vw;
  text-align: center;
}
.header {
  margin-bottom: 22px;
}
.error-title {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #dc3545;
  font-size: 18px;
  font-weight: 700;
}
.error-subtitle {
  color: #dc3545;
  font-size: 15px;
  font-weight: 500;
  margin: 6px 0 0;
}
.info-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 4px 18px 0 rgba(9, 7, 65, 0.16);
  padding: 22px 28px;
  margin: 0 0 22px;
}
.info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 14px;
  align-items: center;
}
.info-label {
  color: #7b7a8c;
  font-size: 15px;
  text-align: right;
}
.info-value {
  color: #090741;
  font-size: 15px;
  font-weight: 700;
  text-align: left;
}
/* Pojedyncze pole (PESEL opiekuna) - box na pełną szerokość jak dla podopiecznego,
   ale etykieta i wartość obok siebie, wyśrodkowane. */
.info-card--single .info-row {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.info-card--single .info-label,
.info-card--single .info-value {
  text-align: center;
}
.question {
  color: #090741;
  font-size: 15px;
  margin-bottom: 18px;
}
/* Separator na pełną szerokość modala - ujemny margines wychodzi poza poziomy padding (32px). */
.divider {
  height: 1px;
  background: rgba(9, 7, 65, 0.08);
  margin: 0 -32px 18px;
}
.buttons {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
</style>
